module.exports = __webpack_public_path__ + "img/atrust.9b169447.png";